import LxcError from "~/core/models/LxcError.class";
import type { SuperAdministration } from "~/modules/superAdministration/models/SuperAdministration.interface";
import superAdministrationService from "~/modules/superAdministration/services/superAdministration.service";

export function useSuperAdministration() {
  const superAdministrationName = ref("");
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();

  async function getSuperAdministration() {
    isLoading.value = true;
    const superAdministration: SuperAdministration =
      await superAdministrationService.getSuperAdministration();
    if (LxcError.check(superAdministration)) {
      error.value = superAdministration;
    } else {
      superAdministrationName.value = superAdministration.name;
    }
    isLoading.value = false;
  }

  return {
    superAdministrationName,
    isLoading,
    error,
    getSuperAdministration,
  };
}
